import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import TimeEntriesTable from "modules/TimeEntries/TimeEntriesTable/TimeEntriesTable";
import CreateTimeEntryModal from "modules/TimeEntries/CreateTimeEntryModal";

export default function TimeEntriesPage() {
  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                display="flex"
                alignItems="center"
                width="100%"
                justifyContent="space-between"
              >
                <MDTypography variant="h4" fontWeight="medium">
                  Time Entries
                </MDTypography>
                <CreateTimeEntryModal />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TimeEntriesTable />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
